import React from 'react';
import { Categories, Category } from 'module/Model/Categories';
import { CategoriesSelector } from 'module/Redux/Categories';
import { connect } from 'react-redux';
import { createPureComponent, PathUtils, TitleUtils } from 'module/Common';
import { Helmet } from 'react-helmet';
import { ItemsGrid } from 'module/View/ItemsGrid';
import { Localized } from 'module/Model/Localized';
import {
  LocalizedText,
  LogoLink,
  Sizes,
  WindowSizeConsumer,
  WishHandler
  } from 'module/View/Common';
import { MainSelector } from 'module/Redux/Main';
import { MenuSelector } from 'module/Redux/Menu';
import { PostList } from 'module/Model/PostList';
import { PostListSelector } from 'module/Redux/PostList';
import { RouterSelector } from 'module/Redux/Router';
import { State } from 'module/Redux';
import { Wish } from 'module/Model/Wish';

const CategoryHandler = WishHandler.create<Category>();

type StateProps = {
  postListWish: Wish<PostList>;
  categoryWish: Wish<Category> | null;
  categoriesWish: Wish<Categories>;
  categoriesIdsInMenu: Wish<Array<number>>;
  lang: PathUtils.Lang;
  touch: boolean;
};

const mapStateToProps = (s: State, props: OwnProps): StateProps => ({
  postListWish: PostListSelector.selectForMatchingRoute(s),
  categoryWish: CategoriesSelector.selectForMatchingRoute(s),
  categoriesWish: CategoriesSelector.selectAll(s),
  lang: RouterSelector.selectLang(s),
  touch: MainSelector.isTouchDetected(s),
  categoriesIdsInMenu: MenuSelector.selectCategoriesIdInMenu(s),
});

type OwnProps = {
  categoryId: number | null;
  availableWidth: number;
};

type Props = OwnProps & StateProps;

const HomeViewComp = createPureComponent<Props>(
  'HomeView',
  ({ postListWish, categoryId, categoryWish, lang, categoriesWish, touch, categoriesIdsInMenu, availableWidth }) => (
    <WindowSizeConsumer>
      {windowSize => {
        const showLogo = !Sizes.isMenuAlwaysVisible(windowSize.width);
        return (
          <>
            {showLogo && <LogoLink centered={true} size={1.3} />}
            {categoryWish && (
              <CategoryHandler
                wish={categoryWish}
                handleVoid={() => null}
                handlePending={() => null}
                handleRejected={() => null}
                handleResolved={category => (
                  <Helmet>
                    <title>{TitleUtils.create(Localized.get(Category.getName(category), lang))}</title>
                  </Helmet>
                )}
              />
            )}
            {(() => {
              const nameTile: Wish<JSX.Element | undefined> = (() => {
                if (!categoryWish) {
                  return Wish.createVoid<any>();
                }
                return Wish.combine([categoriesIdsInMenu, categoryWish], (catsIdsInMenu, category) => {
                  const showTitle =
                    !Sizes.isMenuAlwaysVisible(windowSize.width) ||
                    catsIdsInMenu.indexOf(Category.getId(category)) === -1;
                  return showTitle ? <LocalizedText content={Category.getName(category)} /> : undefined;
                });
              })();
              return (
                <ItemsGrid
                  key="item-grid"
                  nameTile={Wish.getDataOrValue(nameTile, undefined)}
                  postListWish={postListWish}
                  availableWidth={Sizes.getContentWidth(windowSize.width)}
                />
              );
            })()}
          </>
        );
      }}
    </WindowSizeConsumer>
  )
);

export const HomeView = connect(mapStateToProps)(HomeViewComp);



// WEBPACK FOOTER //
// ./src/module/View/HomeView/index.tsx